<template>
  <div class="box">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div class="card_wrap">
      <div class="title_box">
        <h5>{{ language("promotionRules.title") }}</h5>
        <template v-if="$menuList['SIS-Promotions-Rules-Add']">
          <div>
            <el-button type="primary" @click="add">{{
              language("promotionRules.addPromotion")
            }}</el-button>
          </div>
        </template>
      </div>
      <div class="card">
        <div class="status">
          <status-card
            :dataArr="statusArr"
            labelWidth="80px"
            @change="formChange1"
            :title="language('promotionRules.statusArrTitle')"
          ></status-card>
        </div>
        <div class="start_end">
          <start-end-time-card
            :title="language('promotionRules.startEnd')"
            labelPosition="top"
            @change="formChange2"
          ></start-end-time-card>
        </div>
        <div class="input">
          <input-card
            :dataArr="inputArr"
            labelPosition="left"
            labelWidth="150px"
            @change="formChange3"
          ></input-card>
        </div>
      </div>
      <div class="button_wrap">
        <el-button type="primary" @click="search">{{
          language("promotionRules.search")
        }}</el-button>
      </div>
    </div>

    <div class="table_wrap" v-loading="loading">
      <div class="count_box">
        <div class="count">
          {{ language("promotionRules.results") }}: {{ results }}
          {{ language("promotionRules.rows") }}
        </div>
        <div class="page_wrap">
          <page :total="results" @pageChange="pageChange" ref="page"></page>
        </div>
      </div>
      <cc-table
        :loadData="false"
        :dataArr="dataArr"
        :config="table"
        :params="params"
        :refeshParams="refeshTable"
        :emptyText="language('promotionRules.emptyText')"
        :showIndex="false"
        :buttonsWidth="80"
      ></cc-table>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="language('promotionRules.edit')"
      :visible.sync="selectDialog"
      width="90%"
      append-to-body
    >
      <div class="button_type">
        <el-button type="primary" @click="open('flashSale', 1, '', 3)"
          >BasicDiscounts（統一售價）</el-button
        >
        <el-button type="primary" @click="open('flashSale', 2, '', 3)"
          >BasicDiscounts（統一折扣）</el-button
        >
        <el-button type="primary" @click="open('MChooseN', 1, '', 7)"
          >FixedPriceInQty （M選N）</el-button
        >
        <!-- <el-button type="primary" @click="open('MChooseN', 2)"
          >MChooseN （統一折扣）</el-button
        > -->
        <el-button
          type="primary"
          @click="open('buyMoreGetMore', 0, 'piece', 10)"
          >BuyMoreGetMore （買M件打N折）</el-button
        >
        <el-button
          type="primary"
          @click="open('buyMoreGetMore', 0, 'price', 11)"
          >BuyMoreGetMore （買M元打N折）</el-button
        >
      </div>
    </el-dialog>

    <template v-if="dialog">
      <el-dialog
        :close-on-click-modal="false"
        :title="language('promotionRules.edit')"
        :visible.sync="dialog"
        width="90%"
        append-to-body
        v-loading="loading"
      >
        <el-tabs v-model="activeName">
          <el-tab-pane :label="language('promotionRules.tab1')" name="1">
            <el-form
              ref="form1"
              label-width="220px"
              label-position="left"
              :model="addForm"
              :rules="rules"
            >
              <tab1 :formData="addForm" @change="change"></tab1>
            </el-form>
          </el-tab-pane>
          <el-tab-pane
            :label="language('promotionRules.promotionDescription')"
            name="4"
          >
            <el-form ref="form" label-width="200px" label-position="left">
              <tab4 :formData="addForm" @change="change"></tab4>
            </el-form>
          </el-tab-pane>
          <template v-if="addForm.activityType != 'buyMoreGetMore'">
            <el-tab-pane :label="language('promotionRules.tab2')" name="2">
              <el-form
                ref="form2"
                label-width="200px"
                label-position="left"
                :model="addForm"
                :rules="rules"
              >
                <tab2 :formData="addForm" @change="change"></tab2>
              </el-form>
            </el-tab-pane>
          </template>

          <template
            v-if="
              addForm.activityType == 'buyMoreGetMore' &&
              addForm.buyMoreGetMoreType == 'piece'
            "
          >
            <el-tab-pane :label="language('promotionRules.tab2')" name="5">
              <el-form
                ref="form5"
                label-width="0px"
                label-position="left"
                :model="addForm"
                :rules="rules"
              >
                <tab5 :formData="addForm" @change="change"></tab5>
              </el-form>
            </el-tab-pane>
          </template>

          <template
            v-if="
              addForm.activityType == 'buyMoreGetMore' &&
              addForm.buyMoreGetMoreType == 'price'
            "
          >
            <el-tab-pane :label="language('promotionRules.tab2')" name="6">
              <el-form
                ref="form5"
                label-width="0px"
                label-position="left"
                :model="addForm"
                :rules="rules"
              >
                <tab6 :formData="addForm" @change="change"></tab6>
              </el-form>
            </el-tab-pane>
          </template>
        </el-tabs>
        <div class="button_wrap">
          <el-button type="primary" @click="draft('form1')">{{
            language("promotionRules.draftSave")
          }}</el-button>
          <el-button type="primary" @click="submit('form1')">{{
            language("promotionRules.submit")
          }}</el-button>
        </div>
      </el-dialog>
    </template>

    <template v-if="dialogGoods">
      <el-dialog
        :close-on-click-modal="false"
        :title="language('promotionRules.tab3')"
        :visible.sync="dialogGoods"
        width="90%"
        append-to-body
      >
        <el-tabs v-model="activeName">
          <el-tab-pane :label="language('promotionRules.tab3')" name="3">
            <el-form ref="form" label-width="200px" label-position="left">
              <tab3 :formData="addForm"></tab3>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </template>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import statusCard from "../../components/statusCard";
import startEndTimeCard from "../../components/startEndTimeCard";
import inputCard from "../../components/inputCard";
import page from "../../components/page";
import tab1 from "./components/tab1";
import tab2 from "./components/tab2";
import tab3 from "./components/tab3";
import tab4 from "./components/tab4";
import tab5 from "./components/tab5";
import tab6 from "./components/tab6";
export default {
  components: {
    breadcrumb,
    statusCard,
    inputCard,
    startEndTimeCard,
    page,
    tab1,
    tab2,
    tab3,
    tab4,
    tab5,
    tab6,
  },
  data() {
    return {
      loading: false,
      breadcrumb: {
        title: this.language("promotionRules.breadcrumbTitle"),
        list: [
          {
            name: this.language("promotionRules.breadcrumbList_1"),
          },
          {
            name: this.language("promotionRules.breadcrumbList_2"),
          },
        ],
      },
      statusArr: [
        {
          title: "Status",
          checkbox: [],
          list: [
            {
              name: this.language("promotionRules.off"),
              apiName: "status",
              value: 0,
            },
            {
              name: this.language("promotionRules.on"),
              apiName: "status",
              value: 1,
            },
            {
              name: this.language("promotionRules.draft"),
              apiName: "status",
              value: 2,
            },
          ],
        },
      ],

      inputArr: [
        {
          name: "Promotion ID",
          apiName: "id",
          value: "",
        },
        {
          name: "Promotion Name",
          apiName: "activityName",
          value: "",
        },
        {
          name: "Promotion Type",
          apiName: "activityType",
          value: "",
          type: "select",
          options: [
            {
              value: "flashSale",
              label: "BasicDiscounts", //限時促銷
            },
            {
              value: "BuyMoreGetMore",
              label: "BuyMoreGetMore", //多買多折
            },
            {
              value: "MChooseN",
              label: "FixedPriceInQty", //M選N
            },
          ],
        },
      ],
      results: 0,
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      form1: {},
      form2: {},
      params: {},
      refeshTable: -1,
      table: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "id",
            lable: "PromotionID",
            minWidth: 230,
          },
          {
            prop: "createTime",
            lable: this.language("promotionRules.createTime"),
            minWidth: 200,
          },
          {
            prop: "activityType",
            lable: this.language("promotionRules.activityType"), //0無效 1有效
            type: "tag",
            minWidth: 190,
            options: {
              flashSale: {
                tagType: "success",
                text: "BasicDiscounts",
              },
              MChooseN: {
                tagType: "success",
                text: "FixedPriceInQty",
              },
              buyMoreGetMore: {
                tagType: "success",
                text: "BuyMoreGetMore",
              },
            },
          },
          // {
          //   prop: "id",
          //   lable: "ID",
          //   minWidth: 230,
          // },
          {
            prop: "activityName",
            lable: this.language("promotionRules.activityName"),
            minWidth: 150,
          },
          // {
          //   prop: "activityDesc",
          //   lable: this.language("promotionRules.promotionDescription"),
          // },
          // {
          //   prop: "mchShopNum",
          //   lable: "mchShopNum",
          // },
          {
            prop: "startTime",
            lable: this.language("promotionRules.startTime"),
            minWidth: 220,
          },
          {
            prop: "endTime",
            lable: this.language("promotionRules.endTime"),
            minWidth: 210,
          },
          {
            prop: "status",
            lable: this.language("promotionRules.status"), //0無效 1有效
            type: "tag",
            minWidth: 80,

            options: {
              0: {
                tagType: "danger",
                text: this.language("promotionRules.off"),
              },
              1: {
                tagType: "success",
                text: this.language("promotionRules.on"),
              },
              2: {
                tagType: "info",
                text: this.language("promotionRules.draft"),
              },
            },
          },
        ],
        buttons: [
          {
            name: this.language("promotionRules.tab3"),
            click: (row, index) => {
              this.dialogGoods = true;
              this.activeName = "3";
              this.addForm = { ...row };
            },
          },
          {
            name: this.language("promotionRules.edit"),
            click: (row, index) => {
              console.log(row);
              this.dialog = true;
              let type = 2;
              //buyMoreGetMoreType  piece買M件打N折扣 price買M元打N折扣
              let buyMoreGetMoreType = "piece";
              for (
                let i = 0;
                i < row.activityRuleList[0].activityRuleList.length;
                i++
              ) {
                if (
                  row.activityRuleList[0].activityRuleList[i].ruleCode ==
                  "reduce_assgned"
                ) {
                  type = 1;
                }
                if (
                  row.activityRuleList[0].activityRuleList[i].ruleCode ==
                  "reduce_direct_discount"
                ) {
                  type = 2;
                }

                //buyMoreGetMoreType  piece買M件打N折扣 price買M元打N折扣
                if (
                  row.activityRuleList[0].activityRuleList[i].ruleCode ==
                  "reduce_full_discount"
                ) {
                  buyMoreGetMoreType = "price";
                }
              }

              if (row.activityType == "flashSale") {
                if (this.rules.target_order_num) {
                  delete this.rules.target_order_num;
                }
              } else if (row.activityType == "MChooseN") {
                this.rules.target_order_num = [
                  {
                    required: true,
                    trigger: "blur",
                    message: this.language("promotionRules.quantityTips"),
                  },
                ];
              }
              if (row.startTime && row.endTime) {
                row.promotionTime = [row.startTime, row.endTime];
              } else {
                row.promotionTime = [];
              }
              this.addForm = {
                ...row,
                type: type,
                buyMoreGetMoreType: buyMoreGetMoreType,
              };
              this.activeName = "1";
            },
          },
          {
            name: this.language("promotionRules.delete"),
            click: (row, index) => {
              this.delete(row);
            },
          },
        ],
      },
      dialog: false,
      selectDialog: false,
      dialogGoods: false,
      activeName: "1",
      dataArr: [],
      addForm: {},

      rules: {
        imageUrl: [
          {
            required: true,
            trigger: "blur",
            message: this.language("promotionRules.imageUrlEmptyTips"),
          },
        ],
        activityName: [
          {
            required: true,
            trigger: "blur",
            message: this.language("promotionRules.activityNameEmptyTips"),
          },
        ],
        activityType: [
          {
            required: true,
            trigger: "blur",
            message: this.language("promotionRules.activityTypeEmptyTips"),
          },
        ],
        // startTime: [{ required: true, trigger: "blur", message: this.language('promotionRules.startTimeEmptyTips') }],
        // endTime: [{ required: true, trigger: "blur", message: this.language('promotionRules.endTimeEmptyTips') }],
        promotionTime: [
          {
            required: true,
            trigger: "blur",
            message: this.language("promotionRules.promotionTimeTips"),
          },
        ],
        status: [
          {
            required: true,
            trigger: "blur",
            message: this.language("promotionRules.statusEmptyTips"),
          },
        ],
        reduce_assgned: [
          {
            required: true,
            trigger: "blur",
            message: this.language("promotionRules.fixedPriceTips"),
          },
        ],
        reduce_direct_discount: [
          {
            required: true,
            trigger: "blur",
            message: this.language("promotionRules.fixedDiscount"),
          },
        ],
        // target_order_num: [
        //   { required: true, trigger: "blur", message: this.language("promotionRules.quantityTips") },
        // ],
        activityRuleList: [
          { validator: this.checkBuyMoreGetMore, trigger: "blur" },
        ],
      },
      shopData: {},
    };
  },

  methods: {
    checkBuyMoreGetMore(rule, value, callback) {
      let activityRuleList = value[0].activityRuleList;
      let num = 0;
      if (value[0].activityRuleList.length == 0) {
        callback(new Error(this.language('promotionRules.rulesTip')));
      } else {
        for (let i = 0; i < activityRuleList.length; i++) {
          let length = activityRuleList[i].values;
          if (length.indexOf(",") > -1) {
            if (length.split(",").length > 1) {
              num += 1;
            }
          }
          // if (activityRuleList[i].values2 && activityRuleList[i].values) {
          //   num += 1;
          // }
        }
      }
      if (num == 0) {
        callback(new Error(this.language('promotionRules.rulesTip')));
      } else if (num < value[0].activityRuleList.length) {
        callback(new Error(this.language('promotionRules.rulesTip')));
      }
      callback();
    },
    add() {
      // this.dialog = true;
      this.selectDialog = true;
    },
    open(e, num, buyMoreGetMoreType, templateId) {
      //buyMoreGetMoreType  piece買M件打N折扣 price買M元打N折扣
      this.activeName = "1";
      this.dialog = true;
      this.selectDialog = false;
      this.addForm = {
        activityType: e,
        type: num,
        buyMoreGetMoreType: buyMoreGetMoreType,
        templateId: templateId,
      };
      if (e == "flashSale") {
        if (this.rules.target_order_num) {
          delete this.rules.target_order_num;
        }
      } else if (e == "MChooseN") {
        this.rules.target_order_num = [
          {
            required: true,
            trigger: "blur",
            message: this.language("promotionRules.quantityTips"),
          },
        ];
      }
    },
    formChange1(e) {
      this.form1 = { ...e };
      this.svaeForm(e, this.form2, this.form3);
    },
    formChange2(e) {
      this.form2 = { ...e };
      this.svaeForm(this.form1, e, this.form3);
    },
    formChange3(e) {
      this.form3 = { ...e };
      this.svaeForm(this.form1, this.form2, e);
    },
    svaeForm(form1, form2, form3, form4) {
      this.form = {
        ...form1,
        ...form2,
        ...form3,
        ...form4,
      };
    },
    search() {
      this.form.pageSize = 10;
      this.form.pageNo = 1;
      this.getData(this.form);
      this.$refs.page.init();
    },
    pageChange(e) {
      console.log(e);
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.getData(this.form);
    },
    getData(e) {
      this.loading = true;
      e.shopNum = this.shopData.shopNum;
      e.mchShopNum = this.shopData.shopNum;
      this.ccRequest
        .do("admin/merchant/marketing/query", e)
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },

    change(e) {
      this.addForm = {
        ...this.addForm,
        ...e,
      };
    },
    //保存為草稿
    draft(formName) {
      let resultArr = [];
      if (this.addForm.activityType == "flashSale") {
        resultArr.push(this.chekeForm("form2"));
      } else if (this.addForm.activityType == "MChooseN") {
        resultArr.push(this.chekeForm("form2"));
      } else if (this.addForm.activityType == "buyMoreGetMore") {
        resultArr.push(this.chekeForm("form5"));
      }
      let result = Promise.all(resultArr);
      result
        .then((data) => {
          this.save(2);
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.language("common.incorrectInfo"));
        });
    },
    chekeForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    //正常保存
    submit(formName) {
      let resultArr = [this.chekeForm("form1")];
      if (this.addForm.activityType == "flashSale") {
        resultArr.push(this.chekeForm("form2"));
      } else if (this.addForm.activityType == "MChooseN") {
        resultArr.push(this.chekeForm("form2"));
      } else if (this.addForm.activityType == "buyMoreGetMore") {
        resultArr.push(this.chekeForm("form5"));
      }
      let result = Promise.all(resultArr);
      result
        .then((data) => {
          this.save();
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.language("common.incorrectInfo"));
        });
    },
    //保存活動
    save(status) {
      let form = { ...this.addForm };
      if (form.activityDesc && form.activityDesc.indexOf("<iframe") > -1) {
        form.activityDesc = form.activityDesc.replace(
          /<iframe/g,
          `<video controls width="100%"  `
        );
        form.activityDesc = form.activityDesc.replace(/<\/\iframe/g, "</video");
        form.activityDesc = form.activityDesc.replace(
          /frameborder="0" allowfullscreen="true"/g,
          " "
        );
      }
      //去除行內字體大小
      if (form.activityDesc && form.activityDesc.indexOf("font-size:") > -1) {
        form.activityDesc = form.activityDesc.replace(/font-size/g, " ");
      }
      if (status == 2) {
        form.status = 2;
      }
      form.shopNum = this.shopData.shopNum;
      form.mchShopNum = this.shopData.shopNum;
      if (form.promotionTime) {
        form.endTime = form.promotionTime[1];
        form.startTime = form.promotionTime[0];
      } else {
        form.endTime = "";
        form.startTime = "";
      }

      if (!form.activityName) {
        form.activityName = "";
      }
      console.log(form);
      this.ccRequest
        .do("admin/merchant/marketing/save", form, "POSTJSON")
        .then((res) => {
          this.getData(this.form);
          this.dialog = false;
          this.$message({
            type: "success",
            message: this.language("promotionRules.success"),
          });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },

    //刪除
    delete(e) {
      this.$confirm(
        this.language("promotionRules.removeTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do("admin/merchant/marketing/delete", { id: e.id }, "GET")
            .then((res) => {
              this.getData(this.form);
              this.$message({
                type: "success",
                message: this.language("promotionRules.success"),
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    if (!this.$menuList["SIS-Promotions-Rules-Edit"]) {
      this.table.buttons = [];
    }
    let shopData = this.$shopData;
    this.shopData = shopData;
    this.getData({
      pageSize: 10,
      pageNo: 1,
    });
  },
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card_wrap {
  background: #f7f7f7;
  padding: 20px;
  h5 {
    font-size: $title;
    margin: 10px 0 20px 0;
  }
  .card {
    display: flex;
    flex-wrap: wrap;
    .status {
      flex: 1;
    }
    .start_end {
      padding-right: 20px;
      padding-left: 20px;
    }
    .input {
      width: 300px;
      flex: 1;
    }
  }
}

.button_wrap {
  margin-top: 20px;
}
.table_wrap {
  margin-top: 50px;
  .count {
    // font-size: $sbuTitle;
    margin-bottom: 20px;
    font-weight: 600;
  }
  .count_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.page_wrap {
  margin-bottom: 20px;
}
.title_box {
  display: flex;
  justify-content: space-between;
}
.button_wrap {
  margin-top: 20px;
}
.button_type button {
  margin: 10px 10px;
}
</style>
